var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightAngleTopRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83 0C85.7614 0 88 2.23858 88 5V82.0787C88 86.5273 82.6265 88.7608 79.4732 85.6229L40.0977 46.4403L2.37548 8.52657C-0.762057 5.3731 1.47153 0 5.91996 0L83 0Z",
    fill: "#5F5F5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightAngleTopRight);
export default __webpack_public_path__ + "static/media/RightAngle_TopRight.fd51ae0bf61a4c869fc72a99c72b6d34.svg";
export { ForwardRef as ReactComponent };